export const PREVIEW_FOLLOWERS_COUNT = 4

export const RUS_COMPANY_USER_IDS = [6171120, 204072153] // 6171120 - 1org@mail.ru (dev), 204072153 - interacty@sbermarketing.ru (production)
